
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class SecurityMatchRulesetRuleDialog extends  SiteEntityDialog<SecurityMatchRulesetRuleRow, any> {
        protected getFormKey() { return SecurityMatchRulesetRuleForm.formKey; }
        protected getIdProperty() { return SecurityMatchRulesetRuleRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMatchRulesetRuleRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMatchRulesetRuleRow.nameProperty; }
        protected getService() { return SecurityMatchRulesetRuleService.baseUrl; }
        protected getDeletePermission() { return SecurityMatchRulesetRuleRow.deletePermission; }
        protected getInsertPermission() { return SecurityMatchRulesetRuleRow.insertPermission; }
        protected getUpdatePermission() { return SecurityMatchRulesetRuleRow.updatePermission; }


    }
}